// A binding's source: the enclosing component's scoped contexts first (they shadow page globals), then the page.
export function boundSourceContext(name, { inherited = null, lookupGlobal }) {
  return inherited?.[name] ?? lookupGlobal(name) ?? null;
}
